<template>
  <header class="ht-header" role="banner">
    <div class="container">
      <nav class="navbar navbar-default navbar-custom" aria-label="Primary">
        <div class="navbar-header logo">
          <div class="navbar-toggle" data-toggle="collapse" data-target="#main-nav">
            <span class="sr-only">Toggle navigation</span>
            <div id="nav-icon1">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <a href="/"><img class="logo" :src="logoSrc" alt="Filmsomniac" /></a>
        </div>
        <div class="collapse navbar-collapse flex-parent" id="main-nav">
          <ul id="login-block" class="nav navbar-nav flex-child-menu menu-right">
            <li v-if="!isAuthenticated"><a href="/login">login</a></li>
            <li v-if="!isAuthenticated"><a href="/sign-up">Register</a></li>
            <li v-else class="nav-auth-inline">
              <span>{{ auth.state.username }}</span>
              <span class="nav-auth-sep">|</span>
              <a href="/logout">logout</a>
            </li>
          </ul>
        </div>
      </nav>

      <div class="event-list search-panel-wrapper">
        <TopSearchBar />
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import TopSearchBar from './TopSearchBar.vue'
import { useAuthStore } from '../stores/auth'

const logoSrc = '/static/films/legacy/fs-logo-copy-trans-290.png'
const auth = useAuthStore()
const isAuthenticated = computed(() => auth.isAuthenticated.value)
</script>

<style scoped>
.nav-auth-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.nav-auth-sep {
  margin: 0 2px;
}
.nav-auth-inline span:first-child {
  font-size: 14px;
  color: #abb7ce;
  font-weight: 700;
}
</style>
